const draftRegex = /^draft\d$/;

export const isDraftSegment = (segmentId) => {
    return draftRegex.test(segmentId);
};

export const generateNewDraftSegmentId = (existingSegmentIds) => {
    let newSegmentId;
    for (let i = 0; i <= 9; i++) {
        const possibleId = `draft${i}`;
        if (!existingSegmentIds || !existingSegmentIds.includes(possibleId)) {
            newSegmentId = possibleId;
            break;
        }
    }

    return newSegmentId;
};
